<template>
<v-flex class="flex-item-img-and-select">
  <div class="img-and-select" :class="{'pointer': selectionable || clickable}">

    <div class="loader" :class="{'visible': !loader}">
      <v-icon>mdi-loading mdi-spin</v-icon>
    </div>

    <div ref="imgContainer" class="img-container" @dblclick="showImg" @click="selectImg" :class="{'selectable': selectionable, 'img-selected': imgSelected}">
      <img @load="loaded" :src="element.file_url" alt="">
      <button v-if="deletable" @click="$emit('delete', element)" class="btn-delete">
        <img class="delete-img" src="../assets/img/delete-button.png" alt="">
      </button>
    </div>
    <div class="name-container">
      <v-text-field
        v-if="editing"
        class="name-text"
        label="Solo"
        v-model="editingName"
        @blur="updateName"
        @keypress.enter="updateName"
      >
      </v-text-field>
      <div @dblclick="editName" :title="element.name" :class="{'img-selected': imgSelected}" class="name-text">{{name}}</div>

    </div>
    <div v-if="mySelectObj" :title="mySelectObj.selected.labelName">
      <v-select
        class="select"
        v-model="mySelectObj.selected"
        :items="mySelectObj.selectList"
        return-object
        item-text="labelName"
        label="Solo field"
        solo
        :disabled="mySelectObj.selectList.length === 1"
        :class="{'unique-select': mySelectObj.selectList.length === 1}"
      ></v-select>
    </div>
  </div>
</v-flex>
</template>

<script>
export default {
  props: {
    element: {file_url: String, name: String},
    deletable: Boolean || false,
    clickable: Boolean || false,
    selectionable: Boolean || false,
    selectObj: {selectList: Object, selected: Object} || null
  },
  computed: {
    name() {
      let name = this.element.name;
      let lastDot = name.lastIndexOf('.');
      if (lastDot !== -1)
        name = name.slice(0, lastDot);
      this.editingName = name;
      return name
    },
    imgSelected() {
      let selects = this.$store.getters["image/getMultiSelectImg"];
      let selected = selects.includes(this.element.uuid)
      return selected;
    },
  },
  beforeMount() {
    if (this.selectionable === false)
      return this.mySelectObj = null;
    if (!this.element.saliencyreport) return this.selectObj;
    this.organizeReports();
  },
  data() {
    return {
      mySelectObj: {},
      loader: true,
      editing: false,
      editingName: '',
      checkingReport: false
    }
  },
  watch: {
    'mySelectObj.selected' : function(report) {
      let infoReport = {};
      report.srcName = this.element.name;
      infoReport[this.element.uuid] = report;
      this.$emit('update-select', infoReport);
    },
    element: {
      handler(el) {
        if (!!el.aoitestreport)
          this.organizeReports();
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.checkingReport = false;
  },
  methods: {
    loaded() {
      this.loader = false;
    },
    organizeReports() { // seulement dans le cas des projet lorsqu'il faut sélectionner des rapports.
      let aoiReports = this.element.aoitestreport.map((report) => {
        report.labelName = report.aoi_map ? 'AOI: ' + report.name : null;
        return report;
      });
      let basicReport = this.element.saliencyreport;
      basicReport.labelName = basicReport.heat_map ? 'BASIC' : '';
      // TODO lancer une fonction tant que null, request rapport. Si pas null, update store + this.organizeReports (voir si avec update store this.element s'update bien.)
      if (basicReport.heat_map === null && this.checkingReport === false){
        this.checkingReport = true;
        this.checkReport(basicReport, 'heat_map');
      }
      let list = [basicReport, ...aoiReports];
      let waitingList = [];
      list = list.filter(report => {
        if (report.labelName === null) {
          waitingList.push(report);
          return false
        }
        return true
      });
      if (waitingList.length > 0 && this.checkingReport === false) {
        this.checkingReport = true;
        this.checkReport(waitingList[0], 'aoi_map');
      }
      if (list.length > 1)
        list.push({labelName: 'ALL', src: this.element});
      this.$set(this.mySelectObj, 'selected', this.element.saliencyreport);
      this.$set(this.mySelectObj, 'selectList', list);
    },
    checkReport(report, map) {
      if (this.checkingReport === false) return;
      setTimeout(async () => {
        if (map === 'heat_map')
          report = await this.$store.dispatch('report/getReportBASIC', report.uuid);
        else if (map === 'aoi_map') 
          report = await this.$store.dispatch('report/getReportAOI', report.uuid);
        if (report[map] === null)
          this.checkReport(report, map);
        else {
          if (map === 'heat_map')
            this.element.saliencyreport = report;
          else if (map === 'aoi_map') {
            let index = this.element.aoitestreport.findIndex((rep) => report.uuid === rep.uuid);
            this.element.aoitestreport.splice(index, 1, report)
          }
          this.checkingReport = false;
          this.organizeReports();
        }
      }, 10000);
    },
    selectImg() {
      if (this.selectionable === false) return;
      if (this.imgSelected) 
        this.$store.commit("image/unsetMultiSelectImg", this.element.uuid);
      else 
        this.$store.commit("image/setMultiSelectImg", this.element.uuid);
    },
    showImg(e) {
      if (this.clickable === false) return;
      let reportToShow = {};
      reportToShow = this.mySelectObj.selected;
      if (reportToShow.labelName === 'BASIC')
        reportToShow.imgSrc = reportToShow.heat_map;
      else if (reportToShow.labelName.includes('AOI: '))
        reportToShow.imgSrc = reportToShow.aoi_map;
      else reportToShow = null;
      this.$emit('show-img', reportToShow);
    },
    editName(e) {
      if (this.selectionable === false) return
      this.editing = true;
      setTimeout(() => {
        let input = e.target.previousElementSibling.querySelector('input');
        input.select();
      }, 10);
    },
    async updateName(e) {
      try {
        await Promise.all([
          this.$store.dispatch('image/updateMediaName', [this.element.uuid, this.editingName]),
          this.$store.dispatch('report/updateSaliencyName', [this.element.saliencyreport.uuid, this.editingName])
        ]);
        this.element.name = this.editingName;
        this.element.saliencyreport.name = this.editingName;
      } catch(error) {
        console.error(error);
      }
      this.editing = false;
      // dispatch edit puis changer this.element.name ? à voir si on peut changer la props ...
    }
  }
}
</script>
<style lang="sass">
// $text-color: #dfdfdf
$text-color: white
$bg-color: #4a4a4a
$active: #f1e341

.flex-item-img-and-select  
  display: flex !important
  align-items: flex-end
  position: relative
  margin-bottom: 2rem
  padding: 1rem !important
.flex-item.xs1
  padding: .5rem !important
.img-and-select 
  width: 100%
  .img-container
    &>img 
      width: 100%
    .delete-img 
      width: 2.5rem


  // NAME !
  .name-container
    text-align: center
    margin-top: 2rem
    position: relative
    .name-text
      width: 100%
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
      color: $text-color
      font-size: 1.3rem
      background-color: $bg-color
      padding: .2rem .8rem
      text-transform: uppercase
      cursor: default
      transition: color .3s ease-out
      // INPUT NAME
    .v-input 
      padding: 0 !important
      position: absolute
      top: 0
      bottom: 0
      border-bottom: 2px solid darken($text-color, 30%)
      margin-top: 0
      input 
        padding-bottom: .4rem 
        font-size: 1rem
        padding-left: .3rem
        padding-right: .3rem
        background: darken($bg-color, 12%)
      .v-label
        display: none
    .v-text-field__details
      display: none
    .v-input__slot
      width: 100%
      display: block

  .btn-delete 
    position: absolute
    bottom: calc(85% - 2rem)
    right: 0.25rem


  // SELECT !
  .select 
    margin-top: 1rem
    .v-input__slot
      margin-bottom: 0
      min-height: 2.5rem
      height: 2.5rem
    .v-select__selections
      width: calc(100% - 2rem);
    .v-select__selection
      margin: auto !important
      padding-left: 2rem
      color: $text-color
      text-overflow: ellipsis
      display: inline
      overflow: hidden
      white-space: nowrap
    input
      display: none
  .unique-select 
    .v-select__selection
      padding-left: 0
    .v-input__append-inner
      display: none
.xs1
  .img-and-select 
    .v-select__selection
      margin: auto !important
      padding-left: 0
 

  // SELECTABLE !
.img-and-select
  .pointer 
    .selectable 
      cursor: pointer
    .selectable:hover
      border: 2px solid darken($active, 30%)
  .img-container
    padding: 2px
    border: 2px solid transparent
    transition: border .3s ease-out
    .name-text
      width: 50%
    &.img-selected 
      border: 2px solid $active !important
      &:hover
        border: 2px solid darken$active
  .img-selected 
    color: $active !important
    

// LOADER !
.img-and-select
  .loader 
    position: absolute
    top: 0
    bottom: 0
    width: 100%
    background: #171717
    z-index: 2
    display: flex 
    align-items: center
    opacity: 1
    transition: all ease .4s
    &.visible 
      visibility: hidden !important
      transition: visibility linear 0 .5s
      opacity: 0 !important
    i 
      margin: auto
      font-size: 2rem
</style>